import {
  LOGIN_PENDING,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT_PENDING,
  LOGOUT_SUCCESS,
} from '../actions/auth'

const initialState = {
  loggedIn:  false,
  loggingIn: true,  // start in checking-auth state to avoid Login flash on refresh
  apiKey:    null,
  user:      null,
  error:     null,
}

export default function auth(state = initialState, action) {
  switch (action.type) {
    case LOGIN_PENDING:
      return { ...state, loggingIn: true, loggedIn: false }
    case LOGIN_SUCCESS:
      return { ...state, loggingIn: false, loggedIn: true, user: action.user, error: null }
    case LOGIN_ERROR:
      return { ...state, loggingIn: false, loggedIn: false, error: action.error }
    case LOGOUT_PENDING:
      return { ...state, apiKey: null }
    case LOGOUT_SUCCESS:
      return { ...state, loggedIn: false, loggingIn: false, apiKey: null, user: null, error: null }
    default:
      return state
  }
}